import type { IJournalSectionSchema } from "../types/models/Journal.model";
import type { ISection } from "../types";
import { ArticleTypeModel2Interface } from "./ArticleTypeModel2Interface";
import { TaxonomyModel2Interface } from "./TaxonomyModel2Interface";

export const JournalSectionSchema2Interface = (
  journalSectionSchema: IJournalSectionSchema,
  tenantName: string
): ISection => {
  const sectionTitle = journalSectionSchema.Title.replace(
    `${tenantName} in `,
    ""
  );

  return {
    articleTypes: ArticleTypeModel2Interface(journalSectionSchema.ArticleTypes),
    slug: journalSectionSchema.Slug,
    isOnline: journalSectionSchema.Online,
    isOpenForSubmission: journalSectionSchema.OpenForSubmission,
    sectionId: journalSectionSchema.SectionId,
    title: sectionTitle,
    taxonomy: TaxonomyModel2Interface(journalSectionSchema.Taxonomies)
  };
};
